import React from "react";
import StatusApplication from "./StatusApplication";
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const ApprovedApplications = () => {

  const editApplicationPermission = checkPermission(
    permissionsConfig.editApprovedApplications.role,
    permissionsConfig.editApprovedApplications.action,
    permissionsConfig.editApprovedApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteApprovedApplications.role,
    permissionsConfig.deleteApprovedApplications.action,
    permissionsConfig.deleteApprovedApplications.type
  );
  
  return (
    <StatusApplication appStatus="4" title="Accepted" subTitle="Accepted" application_type="0" pageFrom="approved-applications" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
  )
};

export default ApprovedApplications;
